module.exports = __webpack_public_path__ + "media/images/arrow_b_grad-ae5956c1.png";